// same as Office.HostType
export var OfficeHostType;

(function (OfficeHostType) {
  /**
   * The Office host is Microsoft Word.
   */
  OfficeHostType[OfficeHostType["Word"] = 0] = "Word";
  /**
   * The Office host is Microsoft Excel.
   */

  OfficeHostType[OfficeHostType["Excel"] = 1] = "Excel";
  /**
   * The Office host is Microsoft PowerPoint.
   */

  OfficeHostType[OfficeHostType["PowerPoint"] = 2] = "PowerPoint";
  /**
   * The Office host is Microsoft Outlook.
   */

  OfficeHostType[OfficeHostType["Outlook"] = 3] = "Outlook";
  /**
   * The Office host is Microsoft OneNote.
   */

  OfficeHostType[OfficeHostType["OneNote"] = 4] = "OneNote";
  /**
   * The Office host is Microsoft Project.
   */

  OfficeHostType[OfficeHostType["Project"] = 5] = "Project";
  /**
   * The Office host is Microsoft Access.
   *
   * **Important**: We no longer recommend that you create and use Access web apps and databases in SharePoint.
   * As an alternative, we recommend that you use {@link https://powerapps.microsoft.com/ | Microsoft PowerApps}
   * to build no-code business solutions for web and mobile devices.
   */

  OfficeHostType[OfficeHostType["Access"] = 6] = "Access";
  OfficeHostType[OfficeHostType["Unknown"] = 100] = "Unknown";
})(OfficeHostType || (OfficeHostType = {}));